// Global CSS classes
export const CLASSES = {
    shown: 'show',
    open: 'open',
    disabled: 'disabled',
    sticky: 'sticky',
    active: 'active',
    hide: 'd-none',
    modalOpen: 'modal-open',
    isValid: 'is-valid',
    isInvalid: 'is-invalid',
    isError: 'is-error',
    placeholderUp: 'h-placeholder-up',
    animatedTransparent: 'h-transparent-animated',
    overflowHidden: 'h-overflow-hidden',
    expanded: 'expanded',
    flex: 'd-flex',
    selected: 'selected'
};

export const CONFIG = {
    breakpointMedium: 768,
    breakpointDesktop: 1024
};
